module.exports = __webpack_public_path__ + "img/team-members.28821c29.svg";